import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { MagnifyingGlass, Baby, CaretRight } from "@phosphor-icons/react";
import content from "../data/content.json";
import PageHeader from "../components/PageHeader";
import ArticleCard from "../components/ArticleCard";

const ORDER = ["Émotions", "Sommeil", "Allaitement", "Récupération Physique", "Récupération", "Les Indispensables"];

export default function Bibliotheque() {
  const [query, setQuery] = useState("");
  const [cat, setCat] = useState("Tous");

  const categories = useMemo(() => {
    const set = new Set(content.articles.map((a) => a.category));
    const list = [...set].sort((a, b) => {
      const ia = ORDER.indexOf(a);
      const ib = ORDER.indexOf(b);
      return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib);
    });
    return ["Tous", ...list];
  }, []);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    return content.articles.filter((a) => {
      const okCat = cat === "Tous" || a.category === cat;
      const okQ = !q || a.title.toLowerCase().includes(q) || a.excerpt.toLowerCase().includes(q);
      return okCat && okQ;
    });
  }, [query, cat]);

  const total = content.articles.length + content.prema.length + content.products.length;

  return (
    <div>
      <PageHeader title="Bibliothèque" subtitle={`${total} fiches Renaître`} />

      <div className="px-6">
        <div className="flex items-center gap-2 rounded-full border border-[#36302B]/8 bg-white px-4 py-3">
          <MagnifyingGlass size={20} color="#36302B" className="opacity-40" />
          <input
            data-testid="library-search"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Rechercher une fiche…"
            className="w-full bg-transparent text-[15px] text-[#36302B] outline-none placeholder:text-[#36302B]/35"
          />
        </div>
      </div>

      {/* Prematurity — always pinned first */}
      <div className="mt-4 px-6">
        <Link
          to="/prematurite"
          data-testid="library-prema-card"
          className="flex items-center gap-3 rounded-3xl border border-[#D8A7A7]/40 bg-white p-4 shadow-sm transition-transform hover:-translate-y-1"
        >
          <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#9b8ec4]/15">
            <Baby size={26} color="#7E70AE" weight="duotone" />
          </div>
          <div className="flex-1">
            <p className="font-display text-[16px] font-medium text-[#36302B]">Naissance prématurée</p>
            <p className="text-[13px] text-[#36302B]/55">Espace dédié · toujours accessible</p>
          </div>
          <CaretRight size={20} color="#36302B" weight="bold" className="opacity-30" />
        </Link>
      </div>

      {/* Category pills */}
      <div className="mt-4 flex gap-2 overflow-x-auto px-6 pb-1 hide-scrollbar">
        {categories.map((c) => (
          <button
            key={c}
            data-testid={`library-cat-${c}`}
            onClick={() => setCat(c)}
            className="whitespace-nowrap rounded-full px-4 py-2 text-[13px] font-bold transition-colors"
            style={{
              backgroundColor: cat === c ? "#C57B67" : "#FFFFFF",
              color: cat === c ? "#FFFFFF" : "rgba(54,48,43,0.6)",
              border: "1px solid rgba(54,48,43,0.08)",
            }}
          >
            {c}
          </button>
        ))}
      </div>

      <div className="mt-4 grid grid-cols-1 gap-4 px-6 sm:grid-cols-2">
        {filtered.map((a, i) => (
          <div key={a.id} className="fade-up">
            <ArticleCard article={a} index={i} />
          </div>
        ))}
      </div>
      {filtered.length === 0 && (
        <p className="mt-10 px-6 text-center text-[14px] text-[#36302B]/50">
          Aucune fiche ne correspond à votre recherche.
        </p>
      )}
    </div>
  );
}
